import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapMutations, mapActions, mapState } from 'vuex';
import { getBaseResourceType } from '@/store/creative/common/resource';

export default {
  name: 'starButton',

  props: {
    category: [Object]
  },

  data: function data() {
    return {};
  },


  methods: _extends({}, mapMutations({
    updateStars: 'creative/template/updateStars'
  }), mapActions({
    rebuildCategory: 'creative/template/rebuildCategory'
  }), {
    handleClick: function handleClick() {
      this.updateStars({
        type: this.currentTab === 1 ? 'element' : 'gameConfig',
        category: this.curStarsId
      });
      this.rebuildCategory();
    }
  }),

  computed: _extends({}, mapState({
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig;
    },
    starsConfig: function starsConfig(state) {
      return state.creative.template.starsConfig || {};
    },
    currentTab: function currentTab(state) {
      return state.creative.template.currentTab;
    }
  }), {
    linkageArray: function linkageArray() {
      var baseResourceType = getBaseResourceType(this.category.resource_type);
      return _.get(this.templateConfig, ['category_ref', baseResourceType, this.category.prefix], []);
    },
    icon: function icon() {
      return this.isStar ? 'collect_pre' : 'collect';
    },
    buttonClass: function buttonClass() {
      return this.isStar ? 'highlight' : '';
    },
    curStarsConfig: function curStarsConfig() {
      var type = this.currentTab === 1 ? 'element' : 'gameConfig';
      return this.starsConfig[type];
    },
    curStarsId: function curStarsId() {
      var _this = this;

      // 当取消隐藏时，如果当前存在联动元素，则把联动元素组中收藏的id取消收藏即可
      if (this.isStar && this.linkageArray.length) {
        return Number(this.curStarsConfig.find(function (item) {
          return _this.linkageArray.indexOf(item) !== -1;
        }));
      }
      return this.category.id;
    },
    isStar: function isStar() {
      var _this2 = this;

      if (this.curStarsConfig) {
        return this.curStarsConfig.some(function (item) {
          // 如果当前元素含有联动元素，则该元素的联动元素状态也同步
          if (_this2.linkageArray && _this2.linkageArray.length) {
            return _this2.linkageArray.indexOf(item) !== -1;
          }
          return item === _this2.category.id;
        });
      }
      return false;
    }
  })
};